import React from "react";
import { Row, Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useFormContext } from "react-hook-form";
import { ReactComponent as FileIcon } from "assets/images/icons/File.svg";

function Attachment() {
  const methods = useFormContext();
  const { getValues } = methods;

  return (
    <div className="font-b3">
      {getValues("other_attachments")?.length > 0 &&
        getValues("other_attachments").map((attachment: any) => (
          <Row className="mb-2" key={attachment.id}>
            <Col className="text-secondary">
              <FormattedMessage id="new-request.attachments.attachment.attachment" defaultMessage="Attachment" />
            </Col>

            <Col>
              <a target="_blank" href={attachment.url} rel="noopener noreferrer">
                {attachment.name}
              </a>
            </Col>
          </Row>
        ))}
      {getValues("bucket_attachments")?.length > 0 &&
        getValues("bucket_attachments").map((attachment: any, index: number) => (
          <Row className="mb-2" key={`${attachment.id} ${index}`}>
            <Col className="text-secondary">{attachment.bucket_name}</Col>
            <Col>
              <a target="_blank" href={attachment.url} rel="noreferrer">
                <span>
                  <FileIcon />
                </span>
                {attachment.filename}
              </a>
            </Col>
          </Row>
        ))}
      {(!getValues("bucket_attachments") || !getValues("bucket_attachments")?.length) &&
        (!getValues("other_attachments") || !getValues("other_attachments")?.length) && (
          <div className="text-secondary">
            <FormattedMessage id="quote-request-detail.noAttachmentsFound" defaultMessage="No attachments found" />
          </div>
        )}
    </div>
  );
}

export default Attachment;
